import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-layout axxess-planner" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", { class: "page-header" }, null, -1 /* HOISTED */)
const _hoisted_3 = {
  class: "page-content px-0",
  id: "Central__Clinician"
}
const _hoisted_4 = { class: "row-span-3" }
const _hoisted_5 = {
  key: 0,
  class: "banner-container"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaskList = _resolveComponent("TaskList")!
  const _component_PersonalMessageList = _resolveComponent("PersonalMessageList")!
  const _component_PastDue = _resolveComponent("PastDue")!
  const _component_TaskAlerts = _resolveComponent("TaskAlerts")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_TaskList)
      ]),
      _createVNode(_component_PersonalMessageList, { "is-new-scroll": true }),
      _createVNode(_component_PastDue),
      _createVNode(_component_TaskAlerts),
      (_ctx.showBanner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("a", {
              href: _ctx.banner.link,
              target: "_blank",
              rel: "noopener noreferrer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addLog(_ctx.banner)))
            }, [
              _createElementVNode("img", {
                src: _ctx.banner.src,
                class: "axxess-banner"
              }, null, 8 /* PROPS */, _hoisted_7)
            ], 8 /* PROPS */, _hoisted_6),
            _createElementVNode("button", {
              class: "banner-close",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeBanner(_ctx.banner)))
            }, "X")
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}